"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (string) => {
    return (string
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-') // Replace spaces with -
        // Remove all non-word chars
        .replace(/[^\w\-]+/g, '') // eslint-disable-line no-useless-escape
        // Replace multiple - with single -
        .replace(/\-\-+/g, '-') // eslint-disable-line no-useless-escape
    );
};
//# sourceMappingURL=slugify.js.map